<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我的账户" name="first">
            <el-card class="box-card" v-loading="balanceLoading">
            <el-descriptions class="margin-top" title="账户额度信息" :column="3" size="medium">
              <el-descriptions-item label="用户名">{{ balanceInfo.username || '-' }}</el-descriptions-item>
              <el-descriptions-item label="手机号">{{ balanceInfo.phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="会员套餐">{{ balanceInfo.vipLevel || '普通用户' }}</el-descriptions-item>
              <el-descriptions-item label="剩余次数">{{ balanceInfo.remainingCount || 0 }}</el-descriptions-item>
              <el-descriptions-item label="VIP到期时间">
                <span v-if="balanceInfo.vipExpireTime && balanceInfo.vipExpireTime !== '-'">
                  {{ balanceInfo.vipExpireTime }}
                  <el-tag 
                    v-if="vipRemainingDays < 0" 
                    type="danger" 
                    size="mini" 
                    effect="dark"
                    style="margin-left: 8px;">
                    已过期
                  </el-tag>
                  <el-tag 
                    v-else-if="vipRemainingDays <= 7 && vipRemainingDays > 0" 
                    type="warning" 
                    size="mini"
                    style="margin-left: 8px;">
                    即将过期
                  </el-tag>
                </span>
                <span v-else>-</span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ balanceInfo.createTime || '-' }}</el-descriptions-item>
              <el-descriptions-item label="充值时间">{{ balanceInfo.updateTime || '-' }}</el-descriptions-item>
            </el-descriptions>
              </el-card>
            <el-card class="box-card order-card" style="margin-top: 20px;" v-loading="orderLoading">
              <h3>我的订单</h3>
              <el-table :data="tableData" style="width: 100%;">
                <el-table-column prop="rechargeType" label="类型" min-width="100"></el-table-column>
                <el-table-column prop="vipLevel" label="会员等级" min-width="120"></el-table-column>
                <el-table-column prop="amount" label="金额" min-width="100">
                  <template slot-scope="scope">
                    <span>¥{{ scope.row.amount }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="quotaAdded" label="增加额度" min-width="120">
                  <template slot-scope="scope">
                    <span>{{ scope.row.quotaAdded }} 次</span>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderNo" label="订单号" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="paymentMethod" label="支付方式" min-width="120"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="100">
                  <template slot-scope="scope">
                    <el-tag :type="getStatusType(scope.row.status)" size="small">
                      <template v-if="scope.row.status === '0'">支付成功</template>
                      <template v-if="scope.row.status === '1'">支付失败</template>
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" min-width="180">
                  <template slot-scope="scope">
                    <span>{{ formatDateTime(scope.row.createdAt) }}</span>
                  </template>
                </el-table-column>
              </el-table>
              
              <!-- 空状态提示 -->
              <div v-if="tableData.length === 0 && !orderLoading" class="empty-orders">
                <el-empty description="暂无订单记录"></el-empty>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="充值中心" name="second">
            <div class="member-container" v-loading="packagesLoading">
              <!-- 会员状态 -->
              <div class="member-status">
                <h3>
                  {{ balanceInfo.vipLevel || '普通用户' }} 
                  有效期至: {{ balanceInfo.vipExpireTime || '未开通' }} 
                  <template v-if="balanceInfo.vipExpireTime && balanceInfo.vipExpireTime !== '-' && balanceInfo.vipExpireTime !== '未开通'">
                    (<span v-if="vipRemainingDays < 0" style="color: #ffcdd2;">已过期</span><span v-else>剩余{{ vipRemainingDays }}天</span>)
                  </template>
                </h3>
              </div>

              <!-- 会员特权说明 -->
              <div class="privilege-list">
                <h3>会员特权说明:</h3>
                <div class="privilege-item">✔ 购买的会员权益自动叠加，额度立即生效</div>
                <div class="privilege-item">✔ 会员有效期按最长剩余时长计算(例如:原剩余30天，新购90天，最终为90天)</div>
                <div class="privilege-item">✔ 会员等级升级后，可享受更多高级功能和更大配额</div>
                <div class="privilege-item">✔ 所有查询在会员有效期内可持续使用</div>
              </div>

              <!-- 会员套餐选择 -->
              <div class="plan-container">
                <div v-for="plan in memberPlans" :key="plan.id"
                     :class="['plan-card', plan.isCurrent ? 'current' : '', plan.isSpecial ? 'highlight' : '']">
                  <div v-if="plan.isSpecial" class="plan-tag">限时特惠</div>
                  <div class="plan-name">{{ plan.name }}</div>
                  <div class="plan-price">￥{{ plan.price }}</div>
                  <div class="plan-duration">{{ plan.duration }}个月有效期</div>

                  <div class="plan-features">
                    <div class="feature-title">包含功能:</div>
                    <div class="feature-item">
                      ✓ 会员等级: {{ plan.vipLevel }}
                    </div>
                    <div class="feature-item">
                      ✓ 增加额度: <span class="feature-count">{{ plan.viewRecords }}次</span>
                    </div>
                    <div class="feature-item" v-if="plan.description">
                      ✓ {{ plan.description }}
                    </div>
                  </div>

                  <el-button
                      v-if="plan.isCurrent"
                      type="info"
                      class="downgrade-btn"
                      size="small"
                      disabled>
                    当前套餐
                  </el-button>
                  <el-button
                      v-else
                      :type="plan.isSpecial ? 'danger' : 'primary'"
                      class="upgrade-btn"
                      size="small"
                      @click="handleUpgrade(plan)">
                    立即购买
                  </el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="安全设置" name="third">
            <div class="security-container">
              <div class="security-title">管理您的账户安全信息</div>
              <el-card class="box-card">
              <!-- 密码修改部分 -->
              <div class="section">
                <div class="section-title">密码修改</div>
                <div class="section-description">定期更换密码可以提高账户安全性</div>

                <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" class="password-form">
                  <el-form-item label="当前密码" prop="currentPassword">
                    <el-input
                        v-model="passwordForm.currentPassword"
                        type="password"
                        placeholder="请输入当前密码"
                        show-password>
                    </el-input>
                  </el-form-item>

                  <el-form-item label="新密码" prop="newPassword">
                    <el-input
                        v-model="passwordForm.newPassword"
                        type="password"
                        placeholder="请输入新密码"
                        show-password>
                    </el-input>
                  </el-form-item>

                  <el-form-item label="确认新密码" prop="confirmPassword">
                    <el-input
                        v-model="passwordForm.confirmPassword"
                        type="password"
                        placeholder="请再次输入新密码"
                        show-password>
                    </el-input>
                  </el-form-item>

                  <div class="button-group">
                    <el-button type="primary" @click="submitPasswordForm">确认修改</el-button>
                    <el-button @click="resetPasswordForm">重置</el-button>
                  </div>
                </el-form>
              </div>

              <!-- 手机绑定部分 -->
              <div class="section">
                <div class="section-title">手机绑定</div>
                <div class="section-description">绑定手机可以提高账户安全性，并用于接收重要通知（如需修改请到个人资料进行修改）</div>

                <div class="phone-info">
                  <div class="phone-number">已绑定手机: {{ balanceInfo.phone || phoneNumber }}</div>
                </div>
              </div>
                </el-card>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>

    <!-- 套餐确认对话框 -->
    <el-dialog
      title="升级会员"
      :visible.sync="upgradeDialogVisible"
      width="450px"
      center>
      <div class="upgrade-dialog-content" v-if="selectedPlan">
        <div class="dialog-icon">
          <i class="el-icon-info" style="font-size: 24px; color: #409EFF;"></i>
        </div>
        <div class="dialog-message">
          <p style="font-size: 16px; margin: 10px 0;">
            确定要升级到<strong>{{ selectedPlan.name }}</strong>特惠吗？
          </p>
          <div class="plan-info">
            <p><strong>价格：</strong>{{ selectedPlan.price }}元</p>
            <p><strong>时长：</strong>{{ selectedPlan.duration }}个月</p>
            <p><strong>包含：</strong>查看{{ selectedPlan.viewRecords }}条联系信息</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upgradeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpgrade">确认升级</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'Center',
  data() {
    // 确认密码验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      activeName: 'first',
      vipExpiry: '2025-11-17 09:33',
      vipRemainingDays: 0,
      phoneNumber: '13411282495',
      balanceLoading: false,
      orderLoading: false,
      packagesLoading: false,
      balanceInfo: {}, // 账户余额信息
      upgradeDialogVisible: false, // 升级对话框显示状态
      selectedPlan: null, // 选中的套餐
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      tableData: [],
      memberPlans: []
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      // 根据切换的标签页加载不同数据
      if (tab.name === 'first' && !this.balanceInfo.id) {
        this.loadBalanceInfo();
        this.loadMyOrders();
      } else if (tab.name === 'second' && this.memberPlans.length === 0) {
        this.loadVipPackages();
      }
    },
    
    // 加载账户余额信息
    async loadBalanceInfo() {
      this.balanceLoading = true;
      try {
        const res = await request.get('/balance/mine');
        if (res.code === '200') {
          // 映射后端字段到前端字段
          this.balanceInfo = {
            id: res.data.userId,
            username: res.data.userName,
            phone: res.data.phone || '-',
            vipLevel: res.data.vipName || '普通用户',
            vipExpireTime: res.data.vipExpireTime || null,
            remainingCount: res.data.viewRecordsRemaining || 0,
            createTime: res.data.createdAt || '-',
            updateTime: res.data.updatedAt || '-'
          };
          // 计算VIP剩余天数
          this.calculateVipRemainingDays();
        } else {
          this.$message.error(res.msg || '获取账户信息失败');
        }
      } catch (error) {
        // console.error('加载账户信息失败:', error);
        this.$message.error('获取账户信息失败');
      } finally {
        this.balanceLoading = false;
      }
    },
    
    // 加载我的订单
    async loadMyOrders() {
      this.orderLoading = true;
      try {
        const res = await request.get('/order/record/my');
        if (res.code === '200') {
          this.tableData = res.data || [];
        } else {
          this.$message.error(res.msg || '获取订单数据失败');
        }
      } catch (error) {
        // console.error('加载订单数据失败:', error);
        this.$message.error('获取订单数据失败');
      } finally {
        this.orderLoading = false;
      }
    },
    
    // 加载VIP套餐列表
    async loadVipPackages() {
      this.packagesLoading = true;
      try {
        const res = await request.get('/vip/packages/list');
        if (res.code == 200) {
          this.memberPlans = (res.data || []).map(item => ({
            ...item,
            isCurrent: false, // 可以根据用户当前套餐判断
            isSpecial: item.isSpecial || false // 如果后端返回特惠标识
          }));
        } else {
          this.$message.error(res.msg || '获取套餐列表失败');
        }
      } catch (error) {
        // console.error('加载套餐列表失败:', error);
        this.$message.error('获取套餐列表失败');
      } finally {
        this.packagesLoading = false;
      }
    },
    
    // 计算VIP剩余天数
    calculateVipRemainingDays() {
      if (this.balanceInfo.vipExpireTime && this.balanceInfo.vipExpireTime !== '-') {
        const expireDate = new Date(this.balanceInfo.vipExpireTime);
        const today = new Date();
        const diffTime = expireDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        // 允许负数，用于判断是否过期
        this.vipRemainingDays = diffDays;
      } else {
        this.vipRemainingDays = 0;
      }
    },
    
    // 处理套餐升级
    handleUpgrade(plan) {
      // 显示确认对话框
      this.selectedPlan = plan;
      this.upgradeDialogVisible = true;
    },
    
    // 确认升级
    confirmUpgrade() {
      // 关闭对话框
      this.upgradeDialogVisible = false;
      
      // 跳转到充值页面，并传递套餐信息
      this.$router.push({
        path: '/recharge',
        query: {
          packageId: this.selectedPlan.id,
          packageName: this.selectedPlan.name,
          amount: this.selectedPlan.price,
          remark: `购买${this.selectedPlan.name} ${this.selectedPlan.duration}个月有效期`
        }
      });
    },
    
    // 处理套餐降级
    handleDowngrade(plan) {
      this.$message.warning('当前套餐无法降级');
    },
    
    // 提交密码修改表单
    submitPasswordForm() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await request.put('/user/update-password', {
              oldPassword: this.passwordForm.currentPassword,
              newPassword: this.passwordForm.newPassword
            });
            if (res.code === '200') {
              this.$message.success('密码修改成功！请重新登录');
              this.resetPasswordForm();
              // 可以选择跳转到登录页
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            } else {
              this.$message.error(res.msg || '密码修改失败');
            }
          } catch (error) {
            // console.error('修改密码失败:', error);
            this.$message.error('密码修改失败，请稍后重试');
          }
        } else {
          this.$message.warning('请检查表单内容');
          return false;
        }
      });
    },
    
    // 重置密码表单
    resetPasswordForm() {
      this.$refs.passwordForm.resetFields();
    },
    
    // 获取订单状态类型（用于el-tag样式）
    getStatusType(status) {
      const statusMap = {
        '0': 'success',
        '1': 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) {
        return '-';
      }
      // 将 ISO 8601 格式（2025-12-01T14:46:05）转换为 2025-12-01 14:46:05
      return dateTimeStr.replace('T', ' ');
    }
  },
  created() {
    // 页面初始化时加载账户信息和订单
    this.loadBalanceInfo();
    this.loadMyOrders();
  }
}

</script>


<style scoped>
/* ========== 页面容器 ========== */
.box-card {
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  margin: 40px auto;
  max-width: 1400px;
  padding: 0 30px;
}

/* ========== 标签页样式 ========== */
.box-card >>> .el-tabs__header {
  margin: 0;
  padding: 0 var(--spacing-lg);
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(118, 75, 162, 0.03) 100%);
  border-bottom: 2px solid var(--border-lighter);
}

.box-card >>> .el-tabs__item {
  font-size: 16px;
  font-weight: 600;
  height: 60px;
  line-height: 60px;
  padding: 0 30px;
  transition: all 0.3s;
  color: var(--text-secondary);
}

.box-card >>> .el-tabs__item:hover {
  color: var(--primary-color);
}

.box-card >>> .el-tabs__item.is-active {
  color: var(--primary-color);
}

.box-card >>> .el-tabs__active-bar {
  height: 3px;
  background: var(--primary-gradient);
}

/* ========== 我的账户 - 账户信息 ========== */
.box-card >>> .el-descriptions {
  padding: var(--spacing-lg);
}

.box-card >>> .el-descriptions__title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--spacing-lg);
  display: flex;
  align-items: center;
  gap: 10px;
}

.box-card >>> .el-descriptions__title::before {
  content: '';
  width: 4px;
  height: 20px;
  background: var(--primary-gradient);
  border-radius: 2px;
}

.box-card >>> .el-descriptions-item__label {
  font-weight: 600;
  color: var(--text-secondary);
}

.box-card >>> .el-descriptions-item__content {
  color: var(--text-primary);
  font-weight: 500;
  display: flex;
  align-items: center;
}

/* ========== 我的订单表格 ========== */
.box-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 20px 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.order-card {
  padding: 30px !important;
}

.box-card >>> .el-table {
  margin-top: 20px;
  font-size: 14px;
}

.box-card >>> .el-table th {
  background: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
  padding: 14px 0;
}

.box-card >>> .el-table td {
  padding: 14px 0;
}

.box-card >>> .el-table__row:hover {
  background: #f5f7fa !important;
}

/* 空订单状态 */
.empty-orders {
  padding: 40px 20px;
}

/* ========== 充值中心 ========== */
.member-container {
  padding: var(--spacing-xl);
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf2 100%);
  min-height: 500px;
  border-radius: var(--radius-md);
}

.member-status {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 25px;
  border-radius: var(--radius-lg);
  margin-bottom: var(--spacing-lg);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.member-status h3 {
  color: white;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.member-status h3::before {
  content: '👑';
  margin-right: 10px;
}

/* VIP过期提示样式 */
.member-status h3 span[style*="color: #ffcdd2"] {
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: blink 2s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.privilege-list {
  margin-bottom: 30px;
  padding: 25px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.privilege-list h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 20px;
}

.privilege-list h3::before {
  content: '✨';
  margin-right: 10px;
}

.privilege-item {
  margin-bottom: 12px;
  color: var(--text-secondary);
  font-size: 15px;
  padding: 10px 15px;
  background: rgba(102, 126, 234, 0.03);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--primary-color);
  transition: all 0.3s;
}

.privilege-item:hover {
  background: rgba(102, 126, 234, 0.08);
  transform: translateX(5px);
}

.plan-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 24px;
  justify-content: center;
}

.plan-card {
  background: white;
  border: 2px solid #e4e7ed;
  border-radius: var(--radius-lg);
  padding: 30px 25px;
  text-align: center;
  position: relative;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.plan-card:hover {
  border-color: var(--primary-color);
  box-shadow: 0 8px 28px rgba(102, 126, 234, 0.2);
  transform: translateY(-8px);
}

.plan-card.current {
  border-color: #67c23a;
  background: linear-gradient(135deg, rgba(103, 194, 58, 0.05) 0%, rgba(103, 194, 58, 0.02) 100%);
  box-shadow: 0 4px 16px rgba(103, 194, 58, 0.2);
}

.plan-card.highlight {
  border-color: #f56c6c;
  background: linear-gradient(135deg, rgba(245, 108, 108, 0.05) 0%, rgba(245, 108, 108, 0.02) 100%);
  box-shadow: 0 4px 16px rgba(245, 108, 108, 0.2);
}

.plan-tag {
  position: absolute;
  top: -12px;
  right: 20px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  color: white;
  padding: 4px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.plan-name {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.plan-price {
  font-size: 36px;
  font-weight: 700;
  background: var(--primary-gradient);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 8px;
}

.plan-duration {
  color: var(--text-tertiary);
  margin-bottom: 20px;
  font-size: 14px;
}

.plan-features {
  text-align: left;
  margin: 20px 0;
  min-height: 150px;
  padding: 20px;
  background: rgba(102, 126, 234, 0.03);
  border-radius: var(--radius-md);
}

.feature-title {
  font-weight: 700;
  margin-bottom: 15px;
  text-align: center;
  color: var(--text-primary);
  font-size: 15px;
}

.feature-item {
  margin-bottom: 10px;
  font-size: 14px;
  color: var(--text-secondary);
  padding-left: 5px;
}

.feature-count {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 16px;
}

.upgrade-btn, .downgrade-btn {
  width: 100%;
  height: 42px;
  border-radius: 21px;
  font-weight: 700;
  font-size: 15px;
  transition: all 0.3s;
}

.upgrade-btn {
  background: var(--primary-gradient);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.plan-card.highlight .upgrade-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.plan-card.highlight .upgrade-btn:hover {
  box-shadow: 0 6px 20px rgba(245, 108, 108, 0.4);
}

.downgrade-btn {
  background: #e4e7ed;
  color: var(--text-tertiary);
  border: none;
  cursor: not-allowed;
}

/* ========== 安全设置 ========== */
.security-container {
  padding: var(--spacing-xl);
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf2 100%);
  min-height: 500px;
  border-radius: var(--radius-md);
}

.security-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}

.security-title::before {
  content: '🔒';
  font-size: 24px;
}

.security-subtitle {
  color: var(--text-tertiary);
  margin-bottom: 30px;
  font-size: 14px;
}

.section {
  margin-bottom: 30px;
  padding: 30px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title::before {
  content: '';
  width: 4px;
  height: 20px;
  background: var(--primary-gradient);
  border-radius: 2px;
}

.section-description {
  color: var(--text-secondary);
  margin-bottom: 25px;
  font-size: 14px;
  line-height: 1.6;
}

.password-form {
  max-width: 600px;
}

.password-form >>> .el-form-item__label {
  font-weight: 600;
  color: var(--text-secondary);
}

.password-form >>> .el-input__inner {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
  transition: all 0.3s;
}

.password-form >>> .el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.phone-info {
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding: 15px 20px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--primary-color);
}

.phone-number {
  font-weight: 600;
  margin-right: 15px;
  color: var(--text-primary);
  font-size: 16px;
}

.phone-number::before {
  content: '📱';
  margin-right: 10px;
}

.button-group {
  margin-top: 30px;
  display: flex;
  gap: 15px;
}

.button-group >>> .el-button {
  height: 42px;
  padding: 0 30px;
  border-radius: 21px;
  font-weight: 600;
  transition: all 0.3s;
}

.button-group >>> .el-button--primary {
  background: var(--primary-gradient);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.button-group >>> .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.button-group >>> .el-button--default {
  border: 2px solid var(--border-light);
}

.button-group >>> .el-button--default:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

/* ========== 升级对话框 ========== */
.upgrade-dialog-content {
  text-align: center;
  padding: 30px 20px;
}

.dialog-icon {
  margin-bottom: 20px;
}

.dialog-icon i {
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  color: var(--primary-color);
}

.dialog-message {
  color: var(--text-secondary);
}

.dialog-message p {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-primary);
}

.plan-info {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  padding: 20px;
  border-radius: var(--radius-md);
  margin-top: 20px;
  text-align: left;
  border: 2px solid rgba(102, 126, 234, 0.2);
}

.plan-info p {
  margin: 10px 0;
  line-height: 1.8;
  color: var(--text-primary);
  font-size: 15px;
}

.plan-info strong {
  color: var(--primary-color);
}

/* ========== 对话框美化 ========== */
.box-card >>> .el-dialog {
  border-radius: var(--radius-lg);
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
}

.box-card >>> .el-dialog__header {
  background: var(--primary-gradient);
  padding: 20px 30px;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.box-card >>> .el-dialog__title {
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.box-card >>> .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.box-card >>> .el-dialog__footer {
  padding: 20px 30px;
  border-top: 1px solid var(--border-lighter);
}

.dialog-footer >>> .el-button {
  height: 42px;
  padding: 0 30px;
  border-radius: 21px;
  font-weight: 600;
}

.dialog-footer >>> .el-button--primary {
  background: var(--primary-gradient);
  border: none;
}

/* ========== 响应式设计 ========== */
@media (max-width: 768px) {
  .member-container,
  .security-container {
    padding: var(--spacing-md);
  }

  .plan-container {
    grid-template-columns: 1fr;
  }

  .password-form {
    max-width: 100%;
  }

  .button-group {
    flex-direction: column;
  }

  .button-group >>> .el-button {
    width: 100%;
  }
}

/* ========== 动画效果 ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.member-container,
.security-container,
.section {
  animation: fadeInUp 0.6s ease-out;
}

.plan-card {
  animation: fadeInUp 0.6s ease-out;
}

.plan-card:nth-child(1) { animation-delay: 0.1s; }
.plan-card:nth-child(2) { animation-delay: 0.2s; }
.plan-card:nth-child(3) { animation-delay: 0.3s; }
.plan-card:nth-child(4) { animation-delay: 0.4s; }

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
</style>